/** Strippenkaart catalogue prices (EUR, incl. 21% BTW). */
export const STRIPPENKAART_PRIJS_STANDAARD_INCL_BTW = 130;
export const STRIPPENKAART_PRIJS_PROMO_INCL_BTW = 100;

const BTW_FRACTIE = 0.21;

export type BtwBreakdown = {
  subtotaalExclBtw: number;
  btwBedrag: number;
  totaalInclBtw: number;
};

/** Rekent subtotaal excl. BTW en BTW-bedrag af van een inclusief-BTW bedrag (21%). */
export function btwBreakdownVanIncl(inclBtwTotaal: number): BtwBreakdown {
  const subtotaalExclBtw =
    Math.round((inclBtwTotaal / (1 + BTW_FRACTIE)) * 100) / 100;
  const btwBedrag =
    Math.round((inclBtwTotaal - subtotaalExclBtw) * 100) / 100;
  return {
    subtotaalExclBtw,
    btwBedrag,
    totaalInclBtw: inclBtwTotaal,
  };
}

/** Nederlandse weergave voor strippenkaart-orderregels (bijv. € 130,00). */
export function formatStrippenkaartEur(amount: number): string {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
